import React, { useEffect, useRef } from 'react';

import { useWarehousesRequest } from './hooks';

export const TransferablesWarehouseSelect: React.FC<{
  id?: string;
  regionID?: number;
  value?: number;
  className?: string;
  disabled?: boolean;
  excludeID?: number;
  placeholder?: string;
  onChange(value?: number): void;
}> = ({
  id,
  regionID,
  value,
  className = 'form-control',
  disabled,
  excludeID,
  placeholder = ' - Warehouse - ',
  onChange,
}) => {
  const { loading, response } = useWarehousesRequest();
  const warehouses = response?.data ?? [];
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const options = warehouses.filter((warehouse) => {
    if (excludeID != null && warehouse.id === excludeID) {
      return false;
    }
    if (regionID != null && !warehouse.region_ids.includes(regionID)) {
      return false;
    }
    return true;
  });

  useEffect(() => {
    if (value == null || loading || !response) {
      return;
    }

    const stillValid = warehouses.some((warehouse) => {
      if (warehouse.id !== value) {
        return false;
      }
      if (excludeID != null && warehouse.id === excludeID) {
        return false;
      }
      if (regionID != null && !warehouse.region_ids.includes(regionID)) {
        return false;
      }
      return true;
    });

    if (!stillValid) {
      onChangeRef.current(undefined);
    }
  }, [excludeID, loading, regionID, response, value, warehouses]);

  return (
    <select
      id={id}
      className={className}
      disabled={disabled || !!loading}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value ? Number(event.target.value) : undefined)}
    >
      <option value="">{placeholder}</option>
      {options.map((warehouse) => (
        <option key={warehouse.id} value={warehouse.id}>
          {warehouse.name}
        </option>
      ))}
    </select>
  );
};
